import React, { Component} from 'react';
import * as encryptUtils from './encryptDecryptUtils';
import * as scriptUtils from './utils/scriptUtils';
import { IoMdClose } from 'react-icons/io';
import ChatUserInformationProfilePicture from './ChatUserInformationProfilePicture';
import ChatUserNFTUploadModal from './ChatUserNFTUploadModal';
import './ChatUserInformationModal.css';


class ChatUserInformationModal extends Component {
	constructor(props) {
		super(props);
    this.changeUsername = this.changeUsername.bind(this);
    this.selectDefaultPFP = this.selectDefaultPFP.bind(this);
    this.selectNFTPFP = this.selectNFTPFP.bind(this);
    this.setUploadedFile = this.setUploadedFile.bind(this);
    this.submitInformation = this.submitInformation.bind(this);
    this.toggleNFTUploadFlow = this.toggleNFTUploadFlow.bind(this);

    this.state = {
      isOnNFTUploadFlow: false,
      username: '',
      pfp: '',
      isNFTPFP: false,
      readyForSubmit: false,
      uploadedFile: null,
      chosenType: null
    }
	}

  changeUsername(event) {
    this.setState({
      username: event.target.value,
    });
  }

  async submitInformation() {
    let pfp = this.state.pfp;
    if(pfp === '' && this.state.uploadedFile != null) {
      pfp = await encryptUtils.writeSingleFilePinata(this.state.address + "_pfp", this.state.uploadedFile)
    }
    if(pfp === '' || this.state.username === '') {
      return;
    }
    await encryptUtils.updateUserProfileInfo(
      this.props.address,
      this.state.username,
      pfp,
      this.state.isNFTPFP
    );
    this.props.updateUserInfo({
      address: this.props.address,
      username: this.state.username,
      pfp,
      isNFTPFP: this.state.isNFTPFP,
    });
  }

  toggleNFTUploadFlow() {
    this.setState({
      isOnNFTUploadFlow: !this.state.isOnNFTUploadFlow,
    });
  }

  selectDefaultPFP() {
    this.setState({
      pfp: scriptUtils.getProfileImage(this.props.address),
      isNFTPFP: false,
      chosenType: 'default'
    });
  }

  selectNFTPFP(pfp) {
    this.setState({
      pfp,
      isNFTPFP: true,
      chosenType: 'nft'
    });
  }

  setUploadedFile(file) {
    this.setState({
      uploadedFile: file,
      isNFTPFP: false,
      pfp: '',
      chosenType: 'upload'
    });
  }

	render() {
		if(this.state.isOnNFTUploadFlow) {
      return (
        <ChatUserNFTUploadModal
          pfp={this.state.pfp}
          selectNFTPFP={this.selectNFTPFP}
          toggleNFTUploadFlow={this.toggleNFTUploadFlow}
          userOwnedNFTs={this.props.userOwnedNFTs}
        />
      );
    } else {
      return (
        <div>
          <div className="bg-black opacity-50 top-16 md:w-[300px] h-screen mt-0 h-[600px] md:h-[calc(100vh-108px)] absolute z-0">
          </div>
          <div className="modalContainer">
            <div className="flex flex-col justify-center h-full">
              <div className="flex justify-end">
                <IoMdClose
                  className="flex text-xs mr-4 absolute top-[8px] text-base font-medium cursor-pointer text-gray-400"
                  size={20}
                  onClick={() => this.props.setIsInUserProfileFlow(false)}
                />
              </div>
              <div className="text-white text-2xl font-bold justify-center flex" >
                Welcome!
              </div>
              <div className="flex justify-center">
                <div className="text-zinc-500 text-sm text-center justify-center flex w-48 mt-2" >
                  Pick a username and profile picture to start chatting
                </div>
              </div>
              <div className="flex justify-center">
                <div className="w-10/12 mt-4 text-base font-semibold text-zinc-500">
                  USERNAME
                </div>
              </div>
              <form className="flex justify-center mt-1">
                <input
                  className="border-zinc-600 rounded-md border bg-custom-gray text-zinc-400 h-10 w-10/12 px-2"
                  type="text"
                  name="username"
                  maxLength={20}
                  required
                  value={this.state.username}
                  onChange={this.changeUsername}
                />
              </form>
              <ChatUserInformationProfilePicture
                address={this.props.address}
                chosenType={this.state.chosenType}
                selectDefaultPFP={this.selectDefaultPFP}
                toggleNFTUploadFlow={this.toggleNFTUploadFlow}
                userOwnedNFTs={this.props.userOwnedNFTs}
                pfp={this.state.pfp}
                isNFTPFP={this.state.isNFTPFP}
                setUploadedFile={this.setUploadedFile}
              />
              <div className="flex justify-center mt-4">
                <div
                  className={
                    (this.state.pfp !== '' || this.state.uploadedFile != null) && this.state.username !== ''
                      ?
                    "bg-blue-600 w-10/12 cursor-pointer h-10 rounded-md text-white flex justify-center items-center font-semibold"
                      :
                    "bg-gray-600 w-10/12 h-10 rounded-md text-white flex justify-center items-center font-semibold"
                  }
                  onClick={async () => await this.submitInformation()}
                >
                  Submit
                </div>
              </div>
            </div>
          </div>
        </div>
      );
    }
	}
}

export default ChatUserInformationModal;
